export const generateShortUrls = (data) => {
  return fetch('https://link.livinglife.com.tw', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((res) => [res || {}])
    .catch((error) => {
      console.error(error)
      return [undefined, error]
    })
}
